import type { FunctionComponent } from 'react'
import React from 'react'
import { ContentType } from '@which/seatbelt'

import { mapIconType } from '../utils/icon-map'

export const PIArticleInfo: FunctionComponent<Props> = ({ articleType }) => {
  const PIIcon = mapIconType(articleType)

  return (
    <div className="pt-5" data-testid="ea-article-info">
      <ContentType icon={PIIcon} text={articleType} />
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  articleType: string
}
